import { Text, TextSkeleton } from "@clipboard-health/ui-components";

interface ShiftQualificationLabelProps {
  qualificationText: string;
  isLoading?: boolean;
}

/**
 * Displays shift qualification information with loading state support.
 * Shows required qualifications in secondary text color.
 */
export function ShiftQualificationLabel(props: ShiftQualificationLabelProps) {
  const { qualificationText, isLoading } = props;

  if (isLoading) {
    return <TextSkeleton width="2rem" variant="body2" />;
  }

  return (
    <Text
      variant="body2"
      sx={(theme) => ({
        width: "fit-content",
        color: theme.palette.text.secondary,
      })}
    >
      {qualificationText}
    </Text>
  );
}
